import Icon from '../components/Icon.vue'

Icon.register({"address-book":{"width":448,"height":512,"paths":[{"d":"M436 160C442.6 160 448 154.6 448 148V108C448 101.4 442.6 96 436 96H416V48C416 21.5 394.5 0 368 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H368C394.5 512 416 490.5 416 464V416H436C442.6 416 448 410.6 448 404V364C448 357.4 442.6 352 436 352H416V288H436C442.6 288 448 282.6 448 276V236C448 229.4 442.6 224 436 224H416V160H436zM208 128C252.2 128 288 163.8 288 208S252.2 288 208 288 128 252.2 128 208 163.8 128 208 128zM336 360C336 373.3 325.3 384 312 384H104C90.7 384 80 373.3 80 360V341.5C80 319.5 95 300.3 116.4 294.9L152 286C181.1 306.9 226.5 312.9 264 286L299.6 294.9C321 300.3 336 319.5 336 341.5V360z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/address-book.js
// module id = null
// module chunks = 